module.exports = __webpack_public_path__ + "media/images/home/frame-8cefa4258daf522cdc760b778f70182b.svg";